import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['rows', 'row', 'template'];

  addRow() {
    this.rowsTarget.insertAdjacentHTML('beforeend', this.templateTarget.innerHTML);
    this.rowTargets[this.rowTargets.length - 1]?.querySelector('input')?.focus();
  }

  removeRow(event) {
    event.currentTarget.closest('[data-faq-editor-target="row"]')?.remove();
  }
}
